module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('div', {
    staticClass: "main-content container-fluid"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-12"
  }, [_vm._c('PageHeader', {
    attrs: {
      "title": "User Activity Report",
      "subtitle": ""
    }
  }), _vm._v(" "), _vm._c('Panel', {
    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
  }, [_vm._c('div', {
    staticClass: "row  xs-p-40"
  }, [_vm._c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-4 col-form-label",
    attrs: {
      "for": "txtStart"
    }
  }, [_vm._v("Start Date")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-8"
  }, [_vm._c('datepicker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDate),
      expression: "startDate"
    }],
    attrs: {
      "format": "yyyy-MM-dd",
      "name": "startDate",
      "input-class": "form-control"
    },
    domProps: {
      "value": (_vm.startDate)
    },
    on: {
      "input": function($event) {
        _vm.startDate = $event
      }
    }
  })], 1)])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-4 col-form-label",
    attrs: {
      "for": "txtEnd"
    }
  }, [_vm._v("End Date")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-8"
  }, [_vm._c('datepicker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    attrs: {
      "format": "yyyy-MM-dd",
      "name": "endDate",
      "input-class": "form-control"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        _vm.endDate = $event
      }
    }
  })], 1)])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "row xs-p-40 xs-pt-0"
  }, [_vm._c('div', {
    staticClass: "col-xs-12"
  }, [_vm._c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": function($event) {
        _vm.downloadReport()
      }
    }
  }, [_vm._v("Download User Activity Report")])])])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d5220f64!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/users/useractivityreport.vue
// module id = 719
// module chunks = 1